import gql from 'graphql-tag';

export const GET_TIPO_IMPUESTO_BY_CLIENTE = gql`
  query getTipoImpuestoCliente($idCliente: Long!) {
    getTipoImpuestoCliente(idCliente: $idCliente) {
      tipoImpuesto {
        id
        tipo
      }
    }
  }
`

export const ALTA_TIPO_IMPUESTO_CLIENTE = gql`
  mutation altaTipoImpuestoCliente ($altaTipoImpuestoClienteRequest: AltaTipoImpuestoClienteRequestInput) {
    altaTipoImpuestoCliente(altaTipoImpuestoClienteRequest: $altaTipoImpuestoClienteRequest) {
        id
    }
  }
`
